<template>
	<div class="planerBlockTable">
		<v-data-table
				class="planerTable"
				:class="{'disabled': !permissions[9]}"
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:top>
				<div class="tableTop">
					<span>Description</span>
					<button class="btnDrawer" :class="{'disabled': !permissions[9]}" @click="onDrawer(true)">
						<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
					</button>
				</div>
			</template>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.valueFilter]},
                                {'dense': item.dense}]"
							:key="index"
							class=""
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									v-if="item.sortable"
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span
									class="headText wh_w"
									:class="{'headText_sorted': getSortColor(sortBy, item.value), 'center': item.value === 'optional'}">
                  {{ item.text }}
              </span>
							<filter-drop-down v-if="item.func" :item="item">
								<filter-table
										:data-filter="filter[item.value]"
										:type-filter="item.model"
										:item="item"
										:model-filter="item.value"
										:filter-update="filterUpdate"
										:is-disabled="filterPreloader"
										:labelFilter="item.text"
										:uniqId="uniqId"
										@change-sort="changeSort"
										@create-refresh="createRefresh"
										@filter-created="filterCreated"
										@updateFilterListAll="onFilteredAll(item)"
								></filter-table>
							</filter-drop-down>
						</div>
					</th>
					<th></th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="idx"
							:id="item.id"
							:idx="idx"
							:checkClasses="checkClasses"
							:permissions="permissions"
							@updateRepair="onRepair"
							@updateDeleteItem="onDeleteItem"
					></table-tr>
				</template>
				<tr class="tableBottom">
					<td>n: <span>{{ listItems.length }}</span></td>
					<td :key="i" v-for="i in 3"></td>
				</tr>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items && items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:isRefreshPage="isRefreshPage"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
<!--		<description-popup-->
<!--				v-if="drawer"-->
<!--				:createBy="createBy"-->
<!--				@updateDrawer="onDrawer"-->
<!--				@updateSave="onSave"-->
<!--		></description-popup>-->
		<notes-drawer
				v-if="drawer"
				:editItem="createBy"
				@closeDrawer="onDrawer"
				@updateSave="onSave"
		></notes-drawer>
	</div>
</template>

<script>
import { mapActions } from "vuex";
// components
import TableTr from "@/components/Fleet/WorkOrdersStatistics/Planer/RepairsTable/TableTr/TableTr";
// import DescriptionPopup
// from "@/components/Fleet/WorkOrders/AddWorkOrders/FirstTab/DescriptionTable/DescriptionPopup/DescriptionPopup.vue";
// shared
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
import FilterTable from "@/shared/FilterTable/FilterTable";
import Pagination from "@/shared/Pagination/Pagination";
import SortBtn from "@/shared/SortBtn/SortBtn";
// constants
import { repairsHeader, statisticInfoHeader } from "@/constants/defaultHeader";
// helpers
import getUniqId from "@/helper/getUniqId";
import debounce from 'lodash.debounce';
import { formatCurrency } from "@/helper";
import NotesDrawer from "@/shared/Drawers/NotesDrawer/NotesDrawer.vue";

export default {
	name: "RepairsTable",
	components: {
		NotesDrawer,
		FilterDropDown,
		// DescriptionPopup,
		TableTr,
		FilterTable,
		Pagination,
		SortBtn
	},
	props: {
		listItems: Array,
		filter: Object,
		workOrdersFilterDefault: Object,
		permissions: Object,
		getTruckId: Number,
		createBy: String
	},
	computed: {
		headers() {
			return repairsHeader;
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		getTotal() {
			const total = this.listItems.reduce((acc, item) => acc += +item.total, 0);
			return formatCurrency(total);
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
	},
	watch: {
		listItems(val) {
			this.items = val;
		}
	},
	data() {
		return {
			pages: [ 10, 20, 50, 100, 200, 500 ],
			itemsPerPage: 10,
			drawer: false,
			page: 1,
			pageCount: 0,
			filterUpdate: false,
			sortBy: "",
			sortDesc: false,
			menu: false,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			list: this.listItems,
			checkClasses: {},
			filterPreloader: false,
			isRefreshPage: '',
			uniqId: { key: '', id: '' },
			isVisibleItems: false
		};
	},
	methods: {
		...mapActions([ 'onWorkOrdersFilter', 'onWorkOrdersStatisticsFilter' ]),
		onDeleteItem(idx) {
			this.$emit('updateDeleteItem', idx);
		},
		onRepair(values) {
			this.$emit('updateRepair', values);
		},
		onDrawer(value) {
			this.drawer = value;
		},
		onSave(item) {
			this.$emit('updateDescriptionList', item);
			this.drawer = false;
		},
		onFilteredAll(item) {
			this.filterCreated(item.value);
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		toggleOrder(val) {
			const { valueFilter } = statisticInfoHeader.find(item => item.value === val);
			this.sortBy = valueFilter;
			this.sortDesc = !this.sortDesc;
		},
		initWorkOrdersFilter: debounce(async function(values) {
			await this.onWorkOrdersStatisticsFilter(values);
			this.isRefreshPage = getUniqId();
			this.filterPreloader = false;
		}, 800),
		changeSort({ key, value, model }) {
			switch (model) {
				case 'date':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['from'];
					break;
				case 'number':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['type'];
					break;
				case 'note':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'options':
					this.filters[key] = Number(value);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'checkbox':
					this.filters[key] = Number(value);
					break;
				case 'list':
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				default:
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
			}

			this.filterPreloader = true;
			this.initWorkOrdersFilter(this.filters);
		},
		async getFilterList() {
			for (let i = 0; i < this.headers.length; i++) {
				this.filtersMarker[this.headers[i].value] = true;
				this.$set(this.checkClasses, this.headers[i].value, false);
				const value = this.headers[i].value;

				if (value.includes('filter')) {
					this.filters[value] = [];
				}

				this.filtersList[value] = [];
			}
		}
	},
	created() {
		this.getFilterList();
	}
};
</script>

<style scoped lang="scss">
	@import "repairTable";
</style>

<style>
.planerTable .v-data-table__wrapper {
	max-height: 478px;
}
</style>

